import { trackEvent } from 'segment_analytics/events'

const defaultEventProps = {
  platform: 'web',
}

const editStatsViewed = () => {
  return trackEvent('edit_stats_viewed', defaultEventProps)
}

const editStatsTabChanged = ({
  ...props
}: {
  tab: 'summary' | 'annual_stats'
}) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('edit_stats_tab_changed', properties)
}

const editStatsReordered = ({
  ...props
}: {
  chart: string
  new_position: number
  tab: 'summary' | 'annual_stats'
}) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('edit_stats_reordered', properties)
}

const editStatsChartShown = ({ ...props }: { chart: string }) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('edit_stats_chart_shown', properties)
}

const editStatsChartHidden = ({ ...props }: { chart: string }) => {
  const properties = {
    ...defaultEventProps,
    ...props,
  }
  return trackEvent('edit_stats_chart_hidden', properties)
}

const editStatsReset = () => {
  return trackEvent('edit_stats_reset', defaultEventProps)
}

export const statsEdit = {
  editStatsViewed,
  editStatsTabChanged,
  editStatsReordered,
  editStatsChartShown,
  editStatsChartHidden,
  editStatsReset,
}
